let refreshPromise: Promise<boolean> | null = null;

export function attemptRefresh(): Promise<boolean> {
  if (refreshPromise) return refreshPromise;
  const base = import.meta.env.VITE_API_BASE;
  if (!base) return Promise.resolve(false);
  refreshPromise = fetch(`${base}/v1/auth/refresh`, {
    method: "POST",
    credentials: "include",
    headers: { "content-type": "application/json" },
    body: "{}",
  })
    .then((r) => r.ok)
    .catch(() => false)
    .finally(() => { refreshPromise = null; });
  return refreshPromise;
}

export async function authFetch(url: string, init?: RequestInit): Promise<Response> {
  const res = await fetch(url, { ...init, credentials: "include" });
  if (res.status !== 401) return res;
  const refreshed = await attemptRefresh();
  if (refreshed) return fetch(url, { ...init, credentials: "include" });
  if (import.meta.env.VITE_LOGIN_URL) window.location.href = import.meta.env.VITE_LOGIN_URL;
  return res;
}
